import "./MaxContentWrapper.css";

const MaxContentWrapper = ({ children }) => {
  return <div className="max-content-wrapper">{children}</div>;
};

export default MaxContentWrapper;
